// extracted by mini-css-extract-plugin
export default {"empty-container":"off_empty-container__kTh-A","empty-content":"off_empty-content__j89VF","clinic-details":"off_clinic-details__eUuZM"};